<template>
    
    <el-table
        :data="selectedData.data"
        :row-class-name="generateRowClass"
        max-height="600"
        :span-method="handleSpan"
        @current-change="handleRowClick"
        :cell-class-name="generateCellClass"
        :header-cell-class-name="generateHeaderCellClass"
    >

        <template v-if="isTableOne">

            <el-table-column
                prop="category"
                label="类别"
                :width="75"
                align="center"
            >

                <template slot-scope="scope">

                    <span 
                        style="color: #45D7F4; font-weight: bold; font-size: 13px"
                    >

                        <div 
                            v-for="el in scope.row.category.split('、')"
                            :key="el"
                        >
                            {{ el }}
                        </div>
                    </span>
                </template>
            </el-table-column>

            <el-table-column
                prop="cluster"
                label="产业"
                :width="93"
                align="center"
            >

                <template slot-scope="scope">

                    <span 
                        style="color: #FFFFFF"
                    >

                        <div 
                            v-for="el in scope.row.cluster.split('、')"
                            :key="el"
                        >
                            {{ el }}
                        </div>
                    </span>
                </template>
            </el-table-column>

            <el-table-column
                prop="enterprise"
                label="代表企业"
                :width="83"
                align="center"
            >

                <template slot-scope="scope">

                    <div 
                        style="color: #FFFFFF; display: flex; flex-direction: column"
                    >
                        
                        <div 
                            v-for="enterprise in splitEnterprise(scope.row.enterprise)"
                            :key="enterprise"
                        > 
                            {{ enterprise }}
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                prop="goal"
                label="目标/方向"
                align="left"
            >

                <template slot-scope="scope">

                    <span 
                        style="color: #45D7F4"
                    >
                        {{ scope.row.goal }}
                    </span>
                </template>
            </el-table-column>
        </template>

        <template v-else>

            <el-table-column
                prop="category1"
                label="类别"
                :width="110"
                align="center"
            >

                <template slot-scope="scope">

                    <span 
                        style="color: #45D7F4; font-weight: bold; font-size: 14px"
                    >
                        {{ scope.row.category1 }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column
                prop="name"
                label="创新平台"
                align="center"
            >

                <template slot-scope="scope">

                    <div 
                        style="color: #FFFFFF"
                    >

                        <div 
                            v-for="el in scope.row.name.split('、')"
                            :key="el"
                        >
                            {{ el }}
                        </div>
                    </div>
                </template>
            </el-table-column>
        </template>
    </el-table>
</template>

<script>

    import { mapState, mapMutations } from 'vuex';

    import topTableData from '@/data/topTableData';

    export default {
        name: "STTableMain",
        computed: {
            ...mapState(["tOption", "tData"]),
            isTableOne() {
                return [1, 3].includes(this.tOption.type);
            }
        },
        data() {
            return {
                selectedData: []
            };
        },
        methods: {
            ...mapMutations(["updateSelectedPlatform"]),
            generateRowClass({ row }) {

                if (!this.isTableOne) {
                    return "normal-table-row";
                }

                const { category } = row;

                return category.split(",").length > 1? "special-table-row" : "normal-table-row";
            },
            splitEnterprise(enterprise) {
                return enterprise? enterprise.split("、"): "";
            },
            handleSpan({ rowIndex, columnIndex }) {

                if (this.isTableOne) {

                    if (columnIndex === 0) {

                        if ([0, 7].includes(rowIndex)) {

                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        }

                        if (rowIndex === 2) {

                            return {
                                rowspan: 5,
                                colspan: 1
                            };
                        }

                        if ([1, 3, 4, 5, 6, 8].includes(rowIndex)) {

                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        }
                    }
                } else {

                    if (columnIndex === 0) {

                        if ([0].includes(rowIndex)) {

                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        }

                        if ([1, 4, 5, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(rowIndex)) {

                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        }

                        if (rowIndex === 3) {

                            return {
                                rowspan: 3,
                                colspan: 1
                            };
                        }

                        if (rowIndex === 6) {

                            return {
                                rowspan: 11,
                                colspan: 1
                            };
                        }
                    }
                }
            },
            handleRowClick(row) {

                if (this.isTableOne) {
                    return;
                }

                const { type } = this.tOption;

                if (type !== 2) {
                    return;
                }

                const { platform } = this.tData;

                const { value } = platform.filter(element => element.name === row.name)[0];

                this.updateSelectedPlatform({
                    ...row,
                    coord: this.$mapUtils.getPointBMap(value)
                });
            },
            generateCellClass({ columnIndex, row }) {
                return Object.keys(row).filter(el => el !== "id").length - 1 === columnIndex? "st-table-last-col" : "";
            },
            generateHeaderCellClass({ columnIndex, row }) {
                return Object.keys(row).filter(el => el !== "id").length - 1 === columnIndex? "st-table-last-col" : "";
            }
        },
        watch: {
            tOption: {
                immediate: true,
                deep: true,
                handler(val) {

                    if (!val) {
                        return;
                    }

                    const { type } = val;

                    this.selectedData = [1, 3].includes(type)? topTableData[1] : topTableData[2];
                }
            }
        }
    };
</script>

<style lang="scss" scoped>

    /deep/.st-table-last-col {
        border-right: none !important;
    }
</style>